module.exports = __webpack_public_path__ + "img/4.ef931f82.png";